import { Type } from "@sinclair/typebox";
import { JsonObjectSchema } from "./primitives.js";
export const AutonomyModeSchema = Type.Union([Type.Literal("observe"), Type.Literal("draft"), Type.Literal("act_with_approval")]);
export const RiskClassSchema = Type.Union([Type.Literal("observe"), Type.Literal("draft"), Type.Literal("external_write")]);
export const CapabilitySchema = Type.Object({
    schema: Type.Literal("carbon.operations.capability/v1"),
    capability_id: Type.String({ minLength: 1, maxLength: 160, pattern: "^[a-z0-9]+(?:[._-][a-z0-9]+)*$" }),
    title: Type.String({ minLength: 1, maxLength: 120 }), risk_class: RiskClassSchema,
    allowed_autonomy: Type.Array(AutonomyModeSchema, { minItems: 1, uniqueItems: true }),
    input_schema: JsonObjectSchema, output_schema: JsonObjectSchema,
    required_scopes: Type.Array(Type.String({ minLength: 1, maxLength: 100 }), { uniqueItems: true }), enabled: Type.Boolean(),
}, { additionalProperties: false, $id: "carbon.operations.capability/v1" });
export const CapabilityCatalogResponseSchema = Type.Object({
    schema: Type.Literal("carbon.operations.capability.catalog/v1"), capabilities: Type.Array(CapabilitySchema),
}, { additionalProperties: false, $id: "carbon.operations.capability.catalog/v1" });
//# sourceMappingURL=capabilities.js.map